import { h } from 'preact';
import dlv from 'dlv';
import { Text } from 'preact-i18n';

import style from './style';
import pageStyles from '../../pageStyles';

import RecommendedCluster from '../../../clusters/recommended-cluster';
import CategoryCluster from '../../../clusters/category-cluster';
import CustomizedGridCluster from '../../../clusters/customized-grid-cluster';
import { getCommonProps } from '../../../../lib/page';
import { getClusterLink } from '../../../../lib/vertical';
import { SadlibAd } from '../../../pieces/sadlib-ad';
import { TopBorder } from '../../../pieces/top-border';
import { TopBar } from '../../../pieces/topbar';

import { Column, Row, Section, ContainerFluid } from '@cube/layout';
import { MobileHeader } from '@cube/header-widget';


export const Tablet = ({ pageConfig, categoryConfig, browseCategories, mainCategory, ...props }) =>
	(
		<div class={style.tablet}>
			<MobileHeader
				{...props}
				{...pageConfig.header}
			/>
			<TopBar
				type={dlv(categoryConfig, 'topbar')}
			/>
			<ContainerFluid>
				<Section containerClass={pageStyles.defaultTabletPageWidth}>
					<Row class={style.contentRow} key="contentRow">
						<Column>
							<div>
								{ mainCategory &&
									[
										<RecommendedCluster
											{...browseCategories[mainCategory]}
											{...pageConfig.recommendedCluster}
											titleId="titleTop"
											bottomRowCount={4}
											qeId="sc-vertical-main"
											{...getCommonProps(props)}
										/>,
										<SadlibAd id={`sc_vertical_stream1`} type="desktopBanner" />
									]
								}
								{
									categoryConfig.browseClusters.map((browseCategory, i) => (
										<div>
											{
												(mainCategory || i > 0) &&
												<TopBorder />
											}
											{ categoryConfig.browseClusterType === 'grid' ?
												<CustomizedGridCluster
													rowCounts={[2,3]}
													imageRole="w=640,h=360"
													{...categoryConfig.clusterProps}
													{...browseCategories[browseCategory]}
													link={{
														url: getClusterLink({ categoryConfig, browseCategories, browseCategory }),
														label: <Text id="more" />
													}}
													qeId={`sc-vertical-${browseCategory}`}
													{...getCommonProps(props)}
												/>
												:
												<CategoryCluster
													{...browseCategories[browseCategory]}
													{...pageConfig.categoryClusters}
													link={{
														url: getClusterLink({ categoryConfig, browseCategories, browseCategory }),
														label: <Text id="browseCategory" fields={{ category: browseCategories[browseCategory].title }} />
													}}
													bottomRowCount="4"
													qeId={`sc-vertical-${browseCategory}`}
													{...getCommonProps(props)}
												/>
											}
											<SadlibAd id={`sc_vertical_stream${i+2}`} type="desktopBanner" />
										</div>
									))
								}
							</div>
						</Column>
					</Row>
				</Section>
				<SadlibAd id="adhesion" />
			</ContainerFluid>
		</div>
	);
